import { FC } from "react";
import { useLocation } from "react-router-dom";

import { WEB_CONFIG } from "../core/web-config";
import navStyles from "../ui/header/header.module.scss";
import { FullUI } from "../ui/section/full-ui";
import { MainWrapper } from "../ui/section/main-wrapper";
import { Spinner } from "../ui/spinner/spinner";
import styles from "./dummy-ui.module.scss";

export interface DummyUIProps {}

export const DummyUI: FC<DummyUIProps> = ({ children }) => {
  const location = useLocation();

  const isStoryQR =
    !!WEB_CONFIG.QR_MATCH?.STORY_ID &&
    location.pathname === `/${WEB_CONFIG.QR_MATCH.ID}`;

  const isGame =
    /\/gm_/i.test(location.pathname) || /_hotlink/i.test(location.pathname);

  return isGame || isStoryQR ? (
    <div className={styles.gameLoader}>
      {children ? <Spinner stroke="#ffffff" /> : undefined}
    </div>
  ) : (
    <FullUI>
      <nav className={navStyles.navBar}>
        <div className={navStyles.navBarFixed}>
          <div className={navStyles.navBarBackground} />
        </div>
      </nav>
      <MainWrapper>{children}</MainWrapper>
    </FullUI>
  );
};
